import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { Card } from '@/shared/components/ui/card';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

interface DashboardCardProps {
  title: string | ReactNode;
  description: string;
  icon: LucideIcon;
  buttonText: string;
  onClick: () => void;
  className?: string;
}

export function DashboardCard({
  title,
  description,
  icon: Icon,
  buttonText,
  onClick,
  className,
}: DashboardCardProps) {
  return (
    <Card
      className={cn(
        'p-6 hover:shadow-lg transition-shadow cursor-pointer group',
        className,
      )}
      onClick={onClick}
    >
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="p-3 bg-[#026857]/10 rounded-full group-hover:bg-[#026857]/20 transition-colors">
          <Icon className="w-8 h-8 text-[#026857]" />
        </div>

        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <p className="text-sm sm:text-base text-gray-600">{description}</p>
        </div>

        <Button
          className="bg-[#026857] hover:bg-[#025246] text-white"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          {buttonText}
        </Button>
      </div>
    </Card>
  );
}
